import axios from "axios";

export const TYPES = "cms/types";

export function getContentTypes() {
  return axios.get(TYPES)
}
